import { render, staticRenderFns } from "./curriculumPortrait.vue?vue&type=template&id=19628eee&scoped=true"
import script from "./curriculumPortrait.vue?vue&type=script&lang=js"
export * from "./curriculumPortrait.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=19628eee&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/table.scss?vue&type=style&index=1&id=19628eee&prod&lang=scss&scoped=true&external"
import style2 from "./curriculumPortrait.vue?vue&type=style&index=2&id=19628eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19628eee",
  null
  
)

export default component.exports